<template>
  <div>
    <div class="wreppar">
      <div class="headers">
        <Header @messageData="getData"></Header>
      </div>
      <div class="centent">
        <div class="centent_xuan">
          <!-- <div class="xuan_lie">
            <ul class="lie_biao">
              <li>比赛类型:</li>
              <li>锦标赛</li>
              <li>段位赛</li>
              <li>级位赛</li>
            </ul>
            <ul class="lie_biao">
              <li>比赛时间:</li>
              <li>全部近</li>
              <li>一个月近</li>
              <li>三个月</li>
            </ul>
            <ul class="lie_biao">
              <li>城市选择:</li>
              <li>上海</li>
              <li>天津</li>
              <li>深圳</li>
            </ul>
          </div>-->
        </div>
        <div class="centent_center">
          <div class="centent_child">
            <div class="centent_biao" v-for="(item,index) in matchData" :key="index">
              <div class="biao_top" @click="details(index)">
                <div class="biao_img">
                  <img :src="item.image.substring(2,item.image.length-2)" alt />
                </div>
                <div class="biao_left">
                  <p class="biao_tltle">{{item.title}}</p>
                  <div class="biao_logo">
                    <div class="biao_logos">
                      <div class="biao_di">
                        <img src="../../assets/saishiweizhi.png" alt />
                      </div>
                      <p>{{item.provinces}}{{item.city}}</p>
                    </div>
                    <div class="biao_logos logo_left">
                      <div class="biao_shi">
                        <img src="../../assets/saishishijian.png" alt />
                      </div>
                      <p>{{item.game_start_time}}</p>
                    </div>
                  </div>
                  <p class="biao_bao">报名时间：{{item.sign_up_starts}} ~ {{item.sign_up_end}}</p>
                  <p class="biao_bao">比赛时间：{{item.game_start_time}} ~ {{item.game_end_time}}</p>
                  <p class="biao_bao">比赛地点：{{item.venue}}</p>
                </div>
              </div>
              <div class="biao_btn" @click="sign">
                <button>我要报名</button>
              </div>
            </div>
          </div>
          <div class="centent_right">
            <Section></Section>
          </div>
        </div>
        <div class="block" v-if="iftrue">
          <el-pagination
            layout="prev, pager, next"
            :total="370"
            :background="true"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="currentPage"
          ></el-pagination>
        </div>
        <div class="block" v-if="iffalse">
          <el-pagination
            layout="prev, pager, next"
            :total="10"
            :background="true"
            @current-change="handleCurrentChanges"
            :page-size="pageSize"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="bottom">
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>
<script >
import Header from "../header/header.vue";
import Footer from "../footer/footer.vue";
import Section from "../section/section.vue";
export default {
  data() {
    return {
      matchData: [],
      page: 1,
      pageSize: 10,
      currentPage: 1,
      newData: [],
      message: "",
      iftrue: false,
      iffalse: false
    };
  },
  components: { Header, Footer, Section },
  watch: {},
  mounted() {
    this.getDatas();
  },
  methods: {
    getDatas() {
      const rLoading = this.openLoading();
      let that = this;
      that.$http
        .get(
          that.g.ajaxurl +
            "attentions/indexw?page=" +
            that.page +
            "&pageSize=" +
            that.pageSize
        )
        .then(res => {
          that.matchData = res.data.data.items;
          that.iftrue = true;
          rLoading.close();
        });
    },
    getData(val) {
      this.message = val;
      let that = this;
      const rLoading = this.openLoading();
      that.$http
        .get(
          that.g.ajaxurl +
            "attentions/indexw?title=" +
            that.message +
            "&page=" +
            that.page +
            "&pageSize=" +
            that.pageSize
        )
        .then(res => {
          that.matchData = res.data.data.items;
          console.log(that.matchData);
          that.iftrue = false;
          that.iffalse = true;
          rLoading.close();
          if (that.matchData.length == 0) {
            this.getDatas();
            that.iffalse = false;
          }
        });
    },
    sign() {
      this.$router.push({
        path: "/signIn"
      });
    },
    details: function(a) {
      this.$router.push({
        path: "/Tournament",
        query: {
          id: this.matchData[a].id
        }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getDatas();
      document.querySelector("html").scrollTop = 0;
    },
    handleCurrentChanges(val) {
      this.page = val;
      this.getData();
      document.querySelector("html").scrollTop = 0;
    }
  }
};
</script>
<style scoped="scoped">
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.wreppar {
  width: 100%;
}
.headers {
  width: 100%;
}
.centent {
  width: 100%;
  padding-top: 1.85rem;
  /* margin-bottom: 0.3rem; */
}
.centent_center {
  width: 76%;
  margin: 0 auto;
  padding-bottom: 0.6rem;
  display: flex;
  justify-content: space-between;
}
.centent_child {
  width: 68%;
}
.centent_biao {
  width: 100%;
  border-bottom: solid 1px #ccc;
}
.centent_xuan {
  width: 76%;
  margin: 0 auto;
  padding-top: 0.3rem;
}
.xuan_lie {
  width: 100%;
}
.lie_biao {
  font-size: 0.2rem;
  display: flex;
  justify-content: flex-start;
  margin-top: 0.1rem;
  text-align: center;
}
.lie_biao li {
  width: 1rem;
  margin-left: 0.1rem;
}
.biao_top {
  margin-top: 0.3rem;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
}
.biao_img {
  width: 3rem;
  height: 2rem;
  border-radius: 5px;
}
.biao_img img {
  width: 3rem;
  height: 2rem;
  border-radius: 5px;
}
.biao_left {
  margin-left: 0.2rem;
}
.biao_tltle {
  font-size: 0.24rem;
  margin-top: 0.05rem;
}
.biao_tltle:hover {
  color: #fe8f24;
}
.biao_logo {
  display: flex;
  justify-content: flex-start;
  font-size: 0.2rem;
  margin-top: 0.1rem;
}
.biao_logo:hover {
  color: #fe8f24;
}
.biao_logos {
  display: flex;
  justify-content: flex-start;
  font-size: 0.2rem;
}
.biao_logos p {
  margin-left: 0.1rem;
}
.logo_left {
  margin-left: 0.2rem;
}
.biao_bao {
  font-size: 0.2rem;
  margin-top: 0.1rem;
}
.biao_bao:hover {
  color: #fe8f24;
}
.biao_btn {
  text-align: right;
  line-height: 0.2rem;
  margin-bottom: 0.1rem;
}
.biao_btn button {
  border: none;
  outline: none;
  padding: 0 0.3rem;
  line-height: 0.4rem;
  background: #ff9100;
  color: #fff;
  font-size: 0.16rem;
  border-radius: 8px;
  cursor: pointer;
}
.centent_right {
  width: 26%;
}
.block {
  text-align: center;
}
.bottom {
  width: 100%;
}
.biao_di {
  width: 0.2rem;
  height: 0.25rem;
}
.biao_di img {
  width: 0.2rem;
  height: 0.25rem;
}
.biao_shi {
  width: 0.25rem;
  height: 0.25rem;
}
.biao_shi img {
  width: 0.25rem;
  height: 0.25rem;
}
</style>


// WEBPACK FOOTER //
// src/components/page/competition.vue